import { InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { addDays, addMonths, addYears, toDate, parseISO, format, getDate, getDay, setDay, getMonth, setMonth, getDaysInMonth, getYear, parse } from 'date-fns';
import { enUS } from 'date-fns/esm/locale';

import * as ɵngcc0 from '@angular/core';
const NGX_MAT_DATEFNS_DATE_FORMATS = {
    parse: {
        dateInput: 'dd/MM/yyyy',
    },
    display: {
        dateInput: 'dd/MM/yyyy',
        monthYearLabel: 'LLL y',
        dateA11yLabel: 'MMMM d, y',
        monthYearA11yLabel: 'MMMM y',
    },
};

const NGX_MAT_DATEFNS_LOCALES = new InjectionToken('NGX_MAT_DATEFNS_LOCALES');

function range(start, end) {
    const arr = [];
    for (let i = start; i <= end; i++) {
        arr.push(i);
    }
    return arr;
}
class NgxDateFnsDateAdapter extends DateAdapter {
    constructor(dateLocale, locales) {
        super();
        this.locales = locales;
        this.getLocale = (localeCodeOrLocale) => {
            if (localeCodeOrLocale && localeCodeOrLocale.code) {
                return localeCodeOrLocale;
            }
            if (!this.locales || !this.locales.length) {
                throw new Error('locales array does not provided or is empty');
            }
            const locale = this.locales.find((item) => item.code === localeCodeOrLocale);
            if (!locale) {
                throw new Error(`locale '${localeCodeOrLocale}' does not exist`);
            }
            return locale;
        };
        try {
            this.setLocale(dateLocale || enUS);
        }
        catch (err) {
            this.setLocale(enUS);
        }
    }
    setLocale(locale) {
        if (!locale) {
            throw new Error('setLocale should be called with the string locale code or date-fns Locale object');
        }
        this._dateFnsLocale = this.getLocale(locale);
        super.setLocale(locale);
    }
    addCalendarDays(date, days) {
        return addDays(date, days);
    }
    addCalendarMonths(date, months) {
        return addMonths(date, months);
    }
    addCalendarYears(date, years) {
        return addYears(date, years);
    }
    clone(date) {
        return toDate(date);
    }
    createDate(year, month, date) {
        // Check for invalid month and date (except upper bound on date which we have to check after
        // creating the Date).
        if (month < 0 || month > 11) {
            throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
        }
        if (date < 1) {
            throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
        }
        const result = this._createDateWithOverflow(year, month, date);
        // Check that the date wasn't above the upper bound for the month, causing the month to overflow
        if (result.getMonth() !== month) {
            throw Error(`Invalid date "${date}" for month with index "${month}".`);
        }
        return result;
    }
    deserialize(value) {
        if (value) {
            if (typeof value === 'string') {
                return parseISO(value);
            }
            if (typeof value === 'number') {
                return toDate(value);
            }
            if (value instanceof Date) {
                return this.clone(value);
            }
            return null;
        }
        return null;
    }
    format(date, displayFormat) {
        return format(date, displayFormat, { locale: this._dateFnsLocale });
    }
    getDate(date) {
        return getDate(date);
    }
    getDateNames() {
        return range(1, 31).map((day) => String(day));
    }
    getDayOfWeek(date) {
        return getDay(date);
    }
    getDayOfWeekNames(style) {
        const map = {
            long: 'EEEE',
            short: 'EEE',
            narrow: 'EEEEE',
        };
        const formatStr = map[style];
        const date = new Date();
        return range(0, 6).map((month) => format(setDay(date, month), formatStr, {
            locale: this._dateFnsLocale,
        }));
    }
    getFirstDayOfWeek() {
        return this._dateFnsLocale.options.weekStartsOn;
    }
    getMonth(date) {
        return getMonth(date);
    }
    getMonthNames(style) {
        const map = {
            long: 'LLLL',
            short: 'LLL',
            narrow: 'LLLLL',
        };
        const formatStr = map[style];
        const date = new Date();
        return range(0, 11).map((month) => format(setMonth(date, month), formatStr, {
            locale: this._dateFnsLocale,
        }));
    }
    getNumDaysInMonth(date) {
        return getDaysInMonth(date);
    }
    getYear(date) {
        return getYear(date);
    }
    getYearName(date) {
        return format(date, 'yyyy', {
            locale: this._dateFnsLocale,
        });
    }
    invalid() {
        return new Date(NaN);
    }
    isDateInstance(obj) {
        return obj instanceof Date;
    }
    isValid(date) {
        return date instanceof Date && !isNaN(date.getTime());
    }
    parse(value, parseFormat) {
        if (value) {
            if (typeof value === 'string') {
                return parse(value.trim(), parseFormat, new Date(), {
                    locale: this._dateFnsLocale,
                });
            }
            if (typeof value === 'number') {
                return toDate(value);
            }
            if (value instanceof Date) {
                return this.clone(value);
            }
            return null;
        }
        return null;
    }
    toIso8601(date) {
        return date.toISOString();
    }
    today() {
        return new Date();
    }
    /** Creates a date but allows the month and date to overflow. */
    _createDateWithOverflow(year, month, date) {
        const result = new Date(year, month, date);
        // We need to correct for the fact that JS native Date treats years in range [0, 99] as
        // abbreviations for 19xx.
        if (year >= 0 && year < 100) {
            result.setFullYear(this.getYear(result) - 1900);
        }
        return result;
    }
}
NgxDateFnsDateAdapter.ɵfac = function NgxDateFnsDateAdapter_Factory(t) { return new (t || NgxDateFnsDateAdapter)(ɵngcc0.ɵɵinject(MAT_DATE_LOCALE, 8), ɵngcc0.ɵɵinject(NGX_MAT_DATEFNS_LOCALES)); };
NgxDateFnsDateAdapter.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NgxDateFnsDateAdapter, factory: NgxDateFnsDateAdapter.ɵfac });
NgxDateFnsDateAdapter.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [MAT_DATE_LOCALE,] }] },
    { type: Array, decorators: [{ type: Inject, args: [NGX_MAT_DATEFNS_LOCALES,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDateFnsDateAdapter, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_DATE_LOCALE]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [NGX_MAT_DATEFNS_LOCALES]
            }] }]; }, null); })();

class NgxDateFnsDateModule {
}
NgxDateFnsDateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxDateFnsDateModule });
NgxDateFnsDateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxDateFnsDateModule_Factory(t) { return new (t || NgxDateFnsDateModule)(); }, providers: [
        {
            provide: DateAdapter,
            useClass: NgxDateFnsDateAdapter,
            deps: [MAT_DATE_LOCALE, NGX_MAT_DATEFNS_LOCALES]
        },
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDateFnsDateModule, [{
        type: NgModule,
        args: [{
                providers: [
                    {
                        provide: DateAdapter,
                        useClass: NgxDateFnsDateAdapter,
                        deps: [MAT_DATE_LOCALE, NGX_MAT_DATEFNS_LOCALES]
                    },
                ]
            }]
    }], null, null); })();
const ɵ0 = NGX_MAT_DATEFNS_DATE_FORMATS, ɵ1 = [];
class NgxMatDateFnsDateModule {
}
NgxMatDateFnsDateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxMatDateFnsDateModule });
NgxMatDateFnsDateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxMatDateFnsDateModule_Factory(t) { return new (t || NgxMatDateFnsDateModule)(); }, providers: [
        { provide: MAT_DATE_FORMATS, useValue: ɵ0 },
        { provide: NGX_MAT_DATEFNS_LOCALES, useValue: ɵ1 },
    ], imports: [[NgxDateFnsDateModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxMatDateFnsDateModule, { imports: [NgxDateFnsDateModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatDateFnsDateModule, [{
        type: NgModule,
        args: [{
                imports: [NgxDateFnsDateModule],
                providers: [
                    { provide: MAT_DATE_FORMATS, useValue: ɵ0 },
                    { provide: NGX_MAT_DATEFNS_LOCALES, useValue: ɵ1 },
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-mat-datefns-date-adapter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NGX_MAT_DATEFNS_DATE_FORMATS, NGX_MAT_DATEFNS_LOCALES, NgxDateFnsDateAdapter, NgxDateFnsDateModule, NgxMatDateFnsDateModule, ɵ0, ɵ1 };

//# sourceMappingURL=ngx-mat-datefns-date-adapter.js.map